import {
  CLIENTS_FETCH,
  CLIENTS_FETCH_ALL,
  CLIENTS_IS_FETCING,
  CLIENTS_API,
  CLIENT_EDIT,
  CLIENT_FILTER,
  CLEAR_CLIENTS_LIST,
  SET_CLIENT_VIEW_FILTER,
  SET_CLIENT_PROFILE,
  SET_CLIENT_IB
} from 'constants/clients'

//HTTP reuests actions
import {
  put,
  post,
  remove,
  get
} from 'actions/requests'

//Save Clients
export const clientSave = (data) => (dispatch, state) => {
  let action;
  let url;
  let sentData;
  if (data.clientId) {
    action = put;
    url = `${CLIENTS_API}?ibid=${data.ibid}&profileid=${data.profileid}`;
    sentData = data
    delete sentData.ibid
    delete sentData.ibid
  }
  else {
    action = post;
    url = `${CLIENTS_API}?ibid=${data.ibid}&profileid=${data.profileid}`;
    sentData = data
  }

  dispatch(clientsIsFetching(true))
  return action(url, sentData)
      .then((e) => { dispatch(clientsIsFetching(false)); return e; })
      .catch((e) => { dispatch(clientsIsFetching(false)); throw new Error(e) })
}

// Reassign Ib to client
export const clientReassignIb = (data) => (dispatch, state) => {
  const url = `${CLIENTS_API}/${data.clientId}?ibid=${data.ibid}&profileid=${data.profileid}`;
  
  dispatch(clientsIsFetching(true))
  return put(url)
      .then((e) => { dispatch(clientsIsFetching(false)); return e; })
      .catch((e) => { dispatch(clientsIsFetching(false)); throw new Error(e) })
}

//Feth client by id
export const clientFetch = (clinetid, ibid, profileid) => (dispatch, state) => {
      dispatch(clientsIsFetching(true));
      return get(CLIENTS_API + '/' + clinetid, {
        ibid: ibid,
        profileid: profileid,
      }).then((e) => { dispatch(clientsIsFetching(false)); return e; })
}

//Feth all clients
export const clientsFetch = (ibid, profileid, clientName, loading=true) => (dispatch, state) => {
  dispatch(clientsIsFetching(loading));
  const filter = state().clients.pageable
  const sorted = Object.keys(filter.sort).find(e => filter.sort[e])
  let params = {
    size: filter.size,
    page: filter.page,
    sort: sorted + ',' + filter.sort[sorted]
  }
  if(ibid) {
    params.ibid = ibid
  }
  if(profileid) {
    params.profileid = profileid
  }
  if(clientName) {
    params.filter = clientName
  }
  return get(CLIENTS_API, params)
      .then((e) => {
          dispatch(clientsFetched(e.content))
          return e
      })
      .then((e) => {
          dispatch(
              clientFilter({
                  totalPages: e.totalPages
              })
          )
          return e
      })
      //disable loading
      .then((e) => { dispatch(clientsIsFetching(false)); return e; })
}

//Feth all clients
export const clientsFetchAll = (ibid, profileid, clientName, loading=true) => (dispatch, state) => {
  dispatch(clientsIsFetching(loading));
  let params = {
    size: 10000000,
    sort: 'name,asc'
    
  }
  if(ibid) {
    params.ibid = ibid
  }
  if(profileid) {
    params.profileid = profileid
  }
  if(clientName) {
    params.filter = clientName
  }
  return get(CLIENTS_API, params)
      .then((e) => {
          dispatch(clientsFetched(e.content))
          return e
      })
      .then((e) => {
          dispatch(
              clientFilter({
                  totalPages: e.totalPages
              })
          )
          return e
      })
      //disable loading
      .then((e) => { dispatch(clientsIsFetching(false)); return e; })
}


//Remove one client
export const clientRemove = (clinetid, ibid, profileid) => (dispatch, state) => {
  dispatch(clientsIsFetching(true))
  return remove(CLIENTS_API + '/' + clinetid + `?ibid=${ibid}&profileid=${profileid}`)
      .then((e) => {
          dispatch(clientsIsFetching(false));
          return e;
      }).catch((e) => { dispatch(clientsIsFetching(false)); throw new Error(e) })
}


export const clientFetchExternal = (externalClinetid, loading=true) => (dispatch, state) => {
  dispatch(clientsIsFetching(loading));
  return get(CLIENTS_API + '/external/' + externalClinetid)
    .then((e) => {
      dispatch(clientsFetched([e]))
      return e
    })
    .then((e) => { dispatch(clientsIsFetching(false)); return e; })
    .catch((e) => { 
      dispatch(clientsFetched([]))
      dispatch(clientsIsFetching(false))
      throw new Error(e)
    })
}
export const clientsFetched = (payload) => ({ type: CLIENTS_FETCH, payload: payload })
export const clientsFetchedAll = (payload) => ({ type: CLIENTS_FETCH_ALL, payload: payload })
export const clientsIsFetching = (payload) => ({ type: CLIENTS_IS_FETCING, payload: payload })
export const clientEdit = (id, data) => ({ type: CLIENT_EDIT, payload: data })
export const clientFilter = (data) => ({ type: CLIENT_FILTER, payload: data })
export const setClientViewFilter = (data) => ({ type: SET_CLIENT_VIEW_FILTER, payload: data })
export const clearClientsList = () => ({ type: CLEAR_CLIENTS_LIST })
export const setClientProfile = (data) => ({ type: SET_CLIENT_PROFILE, payload: data })
export const setClientIb = (data) => ({ type: SET_CLIENT_IB, payload: data })



// WEBPACK FOOTER //
// ./src/actions/clients.js